import { Model as ORMModel, attr, many } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'

export class Championship extends ORMModel {
  static get genderOptions () {
    return {
      MALE: 'MALE',
      FEMALE: 'FEMALE',
      DEFAULT: 'INTERGENDER'
    }
  }
  static get fields () {
    return {
      id: attr(),

      name: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),

      tier: attr({ getDefault: () => 1 }),

      color: attr({ getDefault: () => '' }),
      backgroundColor: attr({ getDefault: () => '' }),
      gender: attr({ getDefault: () => Championship.genderOptions.DEFAULT }),
      holders: attr({ getDefault: () => 1 }),

      minPoints: attr({ getDefault: () => 0 }),
      maxPoints: attr({ getDefault: () => 100 }),
      rank: attr({ getDefault: () => 100 }),

      brandIds: many({
        to: 'Brand',
        as: 'brands',
        relatedName: 'championshipBrands'
      }),
      wrestlerIds: many({
        to: 'Wrestler',
        as: 'wrestlers',
        relatedName: 'ChampionshipChampions'
      })
    }
  }
  static reducer (action, Model, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_CHAMPIONSHIPS:
        session.Championship.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.ADD_CHAMPIONSHIP:
        Model.upsert({ id: getId(), ...action.payload })
        break
      case Types.GENERATE_CHAMPIONSHIPS:
        action?.payload?.forEach(newItem => {
          session.Championship.upsert(newItem)
        })
      break
      case Types.ASSIGN_TO_BRAND:
        session.Championship.all()
          .toModelArray()
          .forEach(item => {
            item = Model.withId(item.id)
            item.brandIds = [...action.payload]

            item.update(action.payload)
          })
        break
      case Types.DELETE_CHAMPIONSHIP:
        Model.withId(action.payload.id).delete()
        break
      case Types.UPDATE_CHAMPIONSHIP:
        item = Model.withId(action.payload.id)
        if (item) {
          item.update(action.payload)
        }
        break
    }
  }
}

Championship.modelName = 'Championship'

export default Championship
